import React from 'react';
import PropTypes from 'prop-types';
import Title from '../../Sections/Title/Title';
import { commitMutation, graphql } from 'react-relay';
import { GlobalNotifications, Intent } from '../../../Modules';

export default class MpTemplateTitle extends React.Component {

  static propTypes = {
    canEdit: PropTypes.bool.isRequired,
    node: PropTypes.object.isRequired,
    relay: PropTypes.object.isRequired,
    rightAlign: PropTypes.bool
  }

  constructor(props) {
    super(props);
    this.state = {
      title: this.props.node.title
    };
    this.titleChangeHandler = this.titleChangeHandler.bind(this);
    this.updateTitle = this.updateTitle.bind(this);
  }

  titleChangeHandler(e) {
    this.setState({ title: e.target.value });
  }

  updateTitle() {
    const onError = () => {
      GlobalNotifications.show({
        message: 'Unable to update form template title',
        intent: Intent.DANGER
      });
    };
    const onCompleted = () => {
      GlobalNotifications.show({
        message: 'Successfully updated form template title',
        intent: Intent.SUCCESS
      });
    };

    // Set default title if null
    const title = this.state.title ? this.state.title : '(Untitled Music List Template)';
    const { id } = this.props.node;

    if (this.props.node.title !== title) {
      const mutation = graphql`
        mutation Title_UpdateMpTemplateMutation(
          $input: UpdateMpTemplateInput!
        ) {
          updateMpTemplate(input: $input) {
            mp_template {
              id
              title
            }
          }
        }
      `;

      const optimisticResponse = {
        updateMpTemplate: { mp_template: { id, title } }
      };
      const environment = this.props.relay.environment;

      commitMutation(environment, {
        mutation,
        variables: {
          input: {
            id,
            title
          }
        },
        optimisticResponse,
        onCompleted,
        onError
      });
    }
  }

  render() {
    return (
      <Title
        canEdit={this.props.canEdit}
        localTitle={this.state.title}
        title={this.props.node.title}
        titleChangeHandler={this.titleChangeHandler}
        updateTitle={this.updateTitle}
        rightAlign={this.props.rightAlign}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Document/Template/MusicPlanner/Title.js